<template>
    <div class="registration-form">
        <v-card class="popups-register">
            <v-card-title>
                  <span class="back" @click="decrementStep" v-if="step > 1 && step < 4">
                        <svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="3" y="6" width="14" height="2" fill="white"/>
                          <path d="M8 1L2 7L8 13" stroke="white" stroke-width="2"/>
                        </svg>
                  </span>

                <span class="headline" v-if="dialogTitle" v-html="dialogTitle"/>
            </v-card-title>

            <v-card-text class="loading-wrapper">
                <span class="preloader" :style="{backgroundImage: `url('${preloaderBackgroundImage}')`}"
                      v-if="loading"></span>
                <div class="register-step">

                    <div class="register-step__bar" v-if="step < 4">
                        <ul :class="{'max3': phoneVerificationAllowed, 'max2': !phoneVerificationAllowed}">
                            <li class="active">
                                <div class="text">
                                    <div class="text-step">1</div>
                                    <div class="text-name">{{ $t('front.sign_in.register.titles.steps.account') }}</div>
                                </div>
                            </li>
                            <li :class="{active: step >= 2}" v-if="phoneVerificationAllowed">
                                <div class="text">
                                    <div class="text-step">2</div>
                                    <div class="text-name">{{
                                            $t('front.sign_in.register.titles.steps.verification')
                                        }}
                                    </div>
                                </div>
                            </li>
                            <li :class="{active: step >= 3}">
                                <div class="text">
                                    <div class="text-step" v-if="phoneVerificationAllowed">3</div>
                                    <div class="text-step" v-else>2</div>

                                    <div class="text-name">{{ $t('front.sign_in.register.titles.steps.details') }}</div>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div class="register-step__content">
                        <div class="register-step__start" v-if="step < 3">
                            <div class="steps-content">

                                <div class="steps-content__box register-step__one" v-if="step === 1">
                                    <h2>{{ $t('front.sign_in.register.descriptions.create_account') }}</h2>
                                    <v-form ref="formOne" v-model="validStepOne" lazy-validation>
                                        <div class="form-group">
                                            <v-text-field v-model="username" :rules="usernameRules"
                                                          :label="$t('front.sign_in.register.form.username')"
                                                          required autocomplete="off"/>
                                        </div>
                                        <div class="form-group">
                                            <v-text-field type="text" v-model="cpfCnpj" :rules="cpfCnpjRules"
                                                          :label="$t('front.sign_in.register.form.cpf_cnpj')" required
                                                          autocomplete="off"/>
                                        </div>
                                        <div class="form-group">
                                            <v-text-field type="email" v-model="email" :rules="emailRules"
                                                          :label="$t('front.sign_in.register.form.email')"
                                                          required autocomplete="off"></v-text-field>
                                        </div>
                                        <div class="form-group">
                                            <v-text-field type="password" v-model="password" :rules="passwordRules"
                                                          :label="$t('front.sign_in.register.form.password')"
                                                          required autocomplete="off"></v-text-field>
                                        </div>
                                        <div class="form-group">
                                            <v-checkbox v-model="regulationsCheck" :rules="regulationsCheckRules">
                                                <template v-slot:label>
                                                    <div>
                                                        {{ $t('front.sign_in.register.form.terms_conditions.accept') }}
                                                        <a :href="termsAndConditionsRoute" target="_blank" @click.stop>
                                                            {{
                                                                $t('front.sign_in.register.form.terms_conditions.terms_and_conditions')
                                                            }}
                                                        </a>,
                                                        <a :href="privacyAndCookiePolicyRoute" target="_blank"
                                                           @click.stop>
                                                            {{
                                                                $t('front.sign_in.register.form.terms_conditions.privacy_policy')
                                                            }}
                                                        </a>
                                                        {{
                                                            $t('front.sign_in.register.form.terms_conditions.years_old')
                                                        }}
                                                    </div>
                                                </template>
                                            </v-checkbox>
                                        </div>
                                        <div class="form-group">
                                            <v-checkbox v-model="subscribeNewsCheck"
                                                        :label="$t('front.sign_in.register.form.subscribe_newsletter')">
                                            </v-checkbox>
                                        </div>
                                        <v-btn :disabled="!validStepOne || loading" @click="submitFormOne"
                                               v-text="$t('front.modal.buttons.next')"/>
                                    </v-form>

                                    <div class="login">{{ $t('front.sign_in.register.descriptions.already_member') }}
                                        <span @click="openLogin()" v-text="$t('front.sign_in.register.button.login')"/>
                                    </div>
                                </div>

                                <div class="steps-content__box register-step__two" v-if="step === 2">
                                    <h2>{{ $t('front.sign_in.register.descriptions.enter_mobile') }}</h2>

                                    <div class="register-step__two-telephone" v-if="!phoneVerificationCodeSent">
                                        <v-form ref="formTelephone" v-model="validStepTelephone" lazy-validation
                                                v-on:submit.prevent>
                                            <div class="form-group registration-phone">
                                                <vue-tel-input v-model="phone"
                                                               :placeholder="$t('front.sign_in.register.form.phone_number_placeholder')"
                                                               :enabledCountryCode="true"
                                                               :preferredCountries="preferredCountries"
                                                               :mode="'international'"
                                                               :autoDefaultCountry="false"
                                                               :defaultCountry="countryCode"
                                                               @validate="changePhoneValidationStatus"
                                                               @input="phoneInput"/>
                                                <div class="v-text-field__details"
                                                     v-if="phone !== undefined && !isPhoneNumberValid">
                                                    <div class="v-messages theme--dark error--text" role="alert">
                                                        <div class="v-messages__wrapper">
                                                            <div
                                                                class="v-messages__message message-transition-enter-to">
                                                                {{ $t('front.validation.phone_number.valid') }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div id="phone-verification-captcha" v-if="captcha">
                                                <div class="form-group">
                                                    <img :src="captcha.img" alt="Captcha"/>
                                                    <v-btn @click="refreshCaptcha">
                                                        <v-icon>{{ mdiRefresh }}</v-icon>
                                                    </v-btn>
                                                </div>
                                                <div class="form-group">
                                                    <v-text-field type="text" v-model="captchaValue"
                                                                  :rules="captchaValueRules"
                                                                  :label="$t('front.sign_in.register.form.captcha')"
                                                                  required autocomplete="off"/>
                                                </div>
                                            </div>
                                        </v-form>

                                        <v-btn :disabled="!validStepTelephone || !this.isPhoneNumberValid"
                                               @click="submitFormTelephone">
                                            <span v-text="enterPhoneButtonText"/>
                                        </v-btn>

                                        <p v-text="enterPhoneDescription"/>
                                    </div>

                                    <div class="register-step__two-code" v-else>
                                        <div class="info-text">{{
                                                $t('front.sign_in.register.descriptions.code_sent_to_mobile', {phone: phone})
                                            }}
                                        </div>
                                        <v-form>
                                            <div class="form-group">
                                                <input v-model="code_1" type="text"
                                                       @input="verificationCodeInput($event, 1)"
                                                       placeholder="-"
                                                       required>
                                                <input v-model="code_2" type="text"
                                                       @input="verificationCodeInput($event, 2)"
                                                       placeholder="-"
                                                       required>
                                                <input v-model="code_3" type="text"
                                                       @input="verificationCodeInput($event, 3)"
                                                       placeholder="-"
                                                       required>
                                                <input v-model="code_4" type="text"
                                                       @input="verificationCodeInput($event, 4)"
                                                       placeholder="-"
                                                       required>
                                            </div>
                                        </v-form>
                                        <v-btn class="btn-back" @click="editPhoneNumber">
                                            {{ $t('front.sign_in.register.button.edit_phone') }}
                                        </v-btn>
                                        <v-btn :disabled="!phoneCodeValid" @click="submitFormCode">
                                            {{ $t('front.sign_in.register.button.confirm') }}
                                        </v-btn>
                                    </div>
                                </div>

                            </div>
                            <div class="steps-info">
                                <single-page-part :pagePart="registrationPromo"></single-page-part>
                            </div>
                        </div>

                        <div class="register-step__finish register-step__tree" v-if="step === 3">
                            <h2>{{ $t('front.sign_in.register.descriptions.almost_there') }}</h2>
                            <v-form ref="formDetails" v-model="validStepDetails" lazy-validation>

                                <div class="form-group">
                                    <v-text-field type="text" v-model="firstName" :rules="firstNameRules"
                                                  :label="$t('front.sign_in.register.form.first_name')"
                                                  required autocomplete="off"></v-text-field>

                                    <v-text-field type="text" v-model="lastName" :rules="lastNameRules"
                                                  :label="$t('front.sign_in.register.form.last_name')"
                                                  required autocomplete="off"></v-text-field>

                                    <label class="genderLabel">{{ $t('front.sign_in.register.form.gender') }}</label>
                                    <v-radio-group v-model="gender">
                                        <v-radio :label="$t('front.sign_in.register.form.male')" value="Male"></v-radio>
                                        <v-radio :label="$t('front.sign_in.register.form.female')"
                                                 value="Female"></v-radio>
                                    </v-radio-group>

                                    <v-text-field v-model="formattedBirthday"
                                                  :label="$t('front.sign_in.register.form.birthday')"
                                                  :placeholder="birthdayFormat"
                                                  :append-icon="mdiCalendar"
                                                  :rules="birthdayRules"
                                                  @click:append="modalDate = true"/>

                                    <v-dialog ref="modalDate" v-model="modalDate" persistent width="290px">
                                        <v-date-picker v-model="calendarBirthday" scrollable class="customPicker"
                                                       active-picker="YEAR" no-title :picker-date="currentPickerDate"
                                                       :reactive="true" :max="maxAllowedBirthDate">
                                            <v-spacer></v-spacer>
                                            <v-btn text class="btn-picker" @click="modalDate = false">
                                                {{ $t('front.modal.buttons.cancel') }}
                                            </v-btn>
                                            <v-btn text class="btn-picker btn-back" :disabled="!calendarBirthday"
                                                   @click="saveCalendarBirthday">
                                                {{ $t('front.modal.buttons.ok') }}
                                            </v-btn>
                                        </v-date-picker>
                                    </v-dialog>

                                    <div class="d-flex justify-space-between">
                                        <div class="form-group currency-select"
                                             :class="{ 'form-group-nested-left' : !useAgentCode }">
                                            <div id="currency-select" class="select">
                                                <v-select v-model="currency" attach="#currency-select"
                                                          :label="$t('front.sign_in.register.form.currency')"
                                                          :items="supportedCurrenciesCodes"
                                                          :menu-props="{ contentClass: 'menu-custom' }">
                                                </v-select>
                                            </div>
                                        </div>

                                        <div class="form-group form-group-nested-right agent-code"
                                             v-show="useAgentCode">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn absolute icon open-on-click retain-focus-on-click
                                                           v-bind="attrs" v-on="on">
                                                        <svg xmlns="http://www.w3.org/2000/svg"
                                                             xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"
                                                             id="Capa_1" x="0px" y="0px" viewBox="0 0 23.625 23.625"
                                                             style="enable-background:new 0 0 23.625 23.625;"
                                                             xml:space="preserve">
                                                            <g>
                                                                <path style="fill:#333;"
                                                                      d="M11.812,0C5.289,0,0,5.289,0,11.812s5.289,11.813,11.812,11.813s11.813-5.29,11.813-11.813   S18.335,0,11.812,0z M14.271,18.307c-0.608,0.24-1.092,0.422-1.455,0.548c-0.362,0.126-0.783,0.189-1.262,0.189   c-0.736,0-1.309-0.18-1.717-0.539s-0.611-0.814-0.611-1.367c0-0.215,0.015-0.435,0.045-0.659c0.031-0.224,0.08-0.476,0.147-0.759   l0.761-2.688c0.067-0.258,0.125-0.503,0.171-0.731c0.046-0.23,0.068-0.441,0.068-0.633c0-0.342-0.071-0.582-0.212-0.717   c-0.143-0.135-0.412-0.201-0.813-0.201c-0.196,0-0.398,0.029-0.605,0.09c-0.205,0.063-0.383,0.12-0.529,0.176l0.201-0.828   c0.498-0.203,0.975-0.377,1.43-0.521c0.455-0.146,0.885-0.218,1.29-0.218c0.731,0,1.295,0.178,1.692,0.53   c0.395,0.353,0.594,0.812,0.594,1.376c0,0.117-0.014,0.323-0.041,0.617c-0.027,0.295-0.078,0.564-0.152,0.811l-0.757,2.68   c-0.062,0.215-0.117,0.461-0.167,0.736c-0.049,0.275-0.073,0.485-0.073,0.626c0,0.356,0.079,0.599,0.239,0.728   c0.158,0.129,0.435,0.194,0.827,0.194c0.185,0,0.392-0.033,0.626-0.097c0.232-0.064,0.4-0.121,0.506-0.17L14.271,18.307z    M14.137,7.429c-0.353,0.328-0.778,0.492-1.275,0.492c-0.496,0-0.924-0.164-1.28-0.492c-0.354-0.328-0.533-0.727-0.533-1.193   c0-0.465,0.18-0.865,0.533-1.196c0.356-0.332,0.784-0.497,1.28-0.497c0.497,0,0.923,0.165,1.275,0.497   c0.353,0.331,0.53,0.731,0.53,1.196C14.667,6.703,14.49,7.101,14.137,7.429z"/>
                                                            </g>
                                                        </svg>
                                                    </v-btn>
                                                </template>
                                                <span>{{ $t('front.sign_in.register.form.tooltip_bonus_code') }}</span>
                                            </v-tooltip>

                                            <v-text-field type="text" v-model="agentCode"
                                                          :label="$t('front.sign_in.register.form.bonus_code')"
                                                          title="Hello This Will Have Some Value"
                                                          :disabled="!overrideAgentCodeAllowed"
                                                          autocomplete="off"></v-text-field>
                                        </div>
                                    </div>

                                </div>

                                <div class="form-group">
                                    <div id="country-code-select">
                                        <div class="country-code-select-label"
                                             v-text="$t('front.sign_in.register.form.country')"/>
                                        <div id="country-code-select-autocomplete">
                                            <v-autocomplete
                                                :rules="countryRules"
                                                v-model="countryCode"
                                                :items="showingCountries"
                                                item-text="title" item-value="code"
                                                :return-object="false"
                                                attach="#country-code-select-autocomplete"/>
                                        </div>
                                    </div>
                                    <v-text-field type="text" v-model="address" :rules="addressRules"
                                                  label="Address" required autocomplete="off"></v-text-field>

                                    <v-text-field type="text" v-model="city" :rules="cityRules"
                                                  :label="$t('front.sign_in.register.form.city')"
                                                  required autocomplete="off"></v-text-field>

                                    <div id="province-code-select" v-if="showingProvinces.length">
                                        <div class="province-code-select-label"
                                             v-text="$t('front.sign_in.register.form.province')"/>
                                        <div id="province-code-select-autocomplete">
                                            <v-autocomplete
                                                v-model="provinceCode" :rules="provinceRules"
                                                :items="showingProvinces"
                                                item-text="title" item-value="code"
                                                :return-object="false"
                                                attach="#province-code-select-autocomplete">
                                                <template v-slot:no-data="">
                                                    <div class="px-4 text-center">
                                                        {{ $t('front.sign_in.register.form.provinces_not_required') }}
                                                    </div>
                                                </template>
                                            </v-autocomplete>
                                        </div>
                                    </div>

                                    <v-text-field type="text" v-model="postalCode" :rules="postalCodeRules"
                                                  :label="$t('front.sign_in.register.form.postal_code')" required
                                                  autocomplete="off"
                                                  v-if="allowPostalCode"/>
                                </div>

                                <div class="form-group form-groupW100" v-if="!phoneVerificationAllowed">
                                    <label>{{ $t('front.sign_in.register.form.phone_number') }}</label>
                                    <vue-tel-input v-model="phone"
                                                   class="ltr ltr-element"
                                                   :placeholder="$t('front.sign_in.register.form.phone_number_placeholder')"
                                                   :enabledCountryCode="true"
                                                   :preferredCountries="preferredCountries"
                                                   :mode="'international'"
                                                   :autoDefaultCountry="false"
                                                   :defaultCountry="countryCode"
                                                   @validate="changePhoneValidationStatus"
                                                   @input="phoneInput"/>
                                    <div class="v-text-field__details"
                                         v-if="phone !== undefined && !isPhoneNumberValid">
                                        <div class="v-messages theme--dark error--text" role="alert">
                                            <div class="v-messages__wrapper">
                                                <div class="v-messages__message message-transition-enter-to">
                                                    {{ $t('front.validation.phone_number.valid') }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div id="security-question-select" class="form-group form-groupW100 select"
                                     v-if="allowSecurityQuestions">
                                    <v-select v-model="securityQuestion" attach="#security-question-select"
                                              :label="$t('front.sign_in.register.form.security_question')"
                                              :items="securityQuestions" :menu-props="{ contentClass: 'menu-custom' }">
                                    </v-select>
                                </div>

                                <div class="form-group form-groupW100" v-if="allowSecurityQuestions">
                                    <v-text-field type="text" v-model="answer" :rules="answerRules"
                                                  :label="$t('front.sign_in.register.form.security_answer')" required
                                                  autocomplete="off"></v-text-field>
                                </div>

                            </v-form>
                            <v-btn :disabled="!validStepDetails || !this.isPhoneNumberValid || loading"
                                   @click="submitFormDetails">
                                {{ $t('front.sign_in.register.button.register') }}
                            </v-btn>
                        </div>

                        <div class="register-step__success" v-if="step === 4">
                            <h2>{{ $t('front.sign_in.register.descriptions.registration_successful') }}</h2>
                            <p>{{ $t('front.sign_in.register.descriptions.successful_signed') }} <br>
                                {{ $t('front.sign_in.register.descriptions.activate_account') }}
                            </p>
                            <svg width="125" height="125" viewBox="0 0 125 125" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <!--                                <g clip-path="url(#clip0)">-->
                                <g>
                                    <path
                                        d="M119.2 11C119.5 11.6 119.7 12 119.9 12.5C120.4 13.7 120.9 15 121.5 16.2C121.8 16.9 121.7 17.3 121.2 17.8C117.9 21 114.6 24.1 111.5 27.5C107 32.5 102.5 37.6 98.2 42.8C91.2999 51 85.1 59.7 79.3 68.7C73 78.4 67.1 88.3 62.4 98.9C61.9 100.1 61.4 101.3 60.9 102.6C60.9 102.6 60.7999 102.7 60.7 102.8C46 87.7 31.4 72.6 16.7 57.4C17.1 57 17.3999 56.7 17.7999 56.4C20.8999 53.9 24 51.4 27.1 48.8C27.7 48.3 28 48.3 28.6 48.8C36.6 55.2 44.5999 61.5 52.5999 67.9C52.8999 68.1 53.1 68.3 53.4 68.5C72.5 46.1 94.2 26.7 119.2 11Z"
                                        fill="#C4C4C4"/>
                                    <path
                                        d="M83.5999 10.0004C63.9999 3.00039 45.5999 4.90039 28.6999 17.2004C16.2999 26.3004 8.79989 38.8004 6.59989 54.1004C1.89989 86.8004 25.0999 114.3 54.3999 118.2C73.7999 120.8 90.5999 114.9 103.9 100.5C117.2 86.1004 121.2 68.9004 117.5 49.7004C117.7 49.7004 117.9 49.6004 118.1 49.6004C119.7 49.6004 121.2 49.6004 122.8 49.6004C123.3 49.6004 123.6 49.8004 123.6 50.3004C124 53.6004 124.5 56.9004 124.7 60.2004C125.1 66.0004 124.4 71.8004 123 77.4004C120.6 87.3004 116 96.0004 109.2 103.7C103.7 109.9 97.2999 114.9 89.7999 118.5C83.5999 121.5 77.1999 123.5 70.2999 124.3C65.5999 124.9 60.9999 125 56.2999 124.5C43.4999 123.2 32.0999 118.5 22.1999 110.2C15.3999 104.5 10.0999 97.7004 6.19989 89.8004C3.19989 83.7004 1.19989 77.2004 0.39989 70.4004C0.0998899 67.0004 -0.10011 63.6004 -0.000110088 60.1004C0.29989 53.1004 1.59989 46.3004 4.19989 39.8004C9.99989 25.2004 19.8999 14.3004 33.6999 7.00039C40.5999 3.40039 47.8999 1.20039 55.5999 0.400391C64.8999 -0.599609 73.9999 0.400391 82.7999 3.40039C83.4999 3.60039 83.7999 3.90039 83.6999 4.70039C83.5999 6.20039 83.6999 7.70039 83.6999 9.20039C83.6999 9.40039 83.5999 9.70039 83.5999 10.0004Z"
                                        fill="#C4C4C4"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0">
                                        <rect width="124.8" height="124.8" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>

                        <div class="register-step__success" v-if="step === 5">
                            <h2>{{ $t('front.sign_in.register.descriptions.registration_unavailable') }}</h2>
                            <div v-html="registrationUnavailableReason"></div>
                        </div>

                    </div>
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import {VueTelInput} from 'vue-tel-input';
import Toaster from '../../../../../src/mixins/toaster';
import {appCountries} from '../../../../../config/localization';
import moment from 'moment';
import {brandName} from '../../../../../config/app';
import {
    checkPhoneVerificationCode,
    checkRegisterAvailability,
    fetchRegistrationFormData,
    checkUserRegistrationData,
    registerUser,
    sendPhoneVerificationCode,
    getPhoneVerificationCaptcha, checkUserRegistrationPhone, loginUser
} from "../../../../../src/api";
import apiData from "../../../../../src/mixins/apiData";
import {VAutocomplete} from 'vuetifyComponents/VAutocomplete'; // alias
import {VDatePicker} from 'vuetifyComponents/VDatePicker'; // alias
import {VCheckbox} from 'vuetifyComponents/VCheckbox'; // alias
import {VRadioGroup, VRadio} from 'vuetifyComponents/VRadioGroup'; // alias
import {VTooltip} from 'vuetifyComponents/VTooltip'; // alias
import {mdiRefresh} from '@mdi/js';
import {createLoginData} from 'vendorModules/user/loginData';
import eventsInterface from "../../../../../src/interfaces/eventsInterface";
import {
    clearReferralData,
    createRegistrationUserTrackingCodes, getStoredReferralLinkCode,
} from "../../../../../src/util/agent/registrationReferralDataManager";
import {mdiCalendar} from '@mdi/js';

export default {
    name: 'RegistrationForm',

    components: {VueTelInput, VDatePicker, VCheckbox, VRadioGroup, VRadio, VTooltip, VAutocomplete},

    mixins: [Toaster, apiData],

    data: function () {
        return {
            mdiCalendar: mdiCalendar,
            minUserAgeForRegistration: undefined,
            loading: false,
            useAgentCode: false,
            overrideAgentCodeAllowed: false,
            loginUserAfterRegistration: false,
            step: 0,
            registrationUnavailableReason: '',
            validStepOne: true,
            validStepTelephone: false,
            phoneCodeValid: false,
            validStepDetails: false,
            phoneVerificationAllowed: false,
            captcha: undefined,
            captchaValue: undefined,
            captchaValueRules: [
                v => !!v || this.$t('front.validation.captcha.required'),
            ],
            code_1: '',
            code_2: '',
            code_3: '',
            code_4: '',
            code: '',
            phoneVerificationCodeSent: false,
            formattedBirthday: null,
            calendarBirthday: null,
            maxAllowedBirthDate: undefined,
            currentPickerDate: undefined,
            modalDate: false,
            gender: 'Male',
            countryCode: null,
            countryRules: [
                v => !!v || this.$t('front.validation.country.required'),
            ],
            provinceCode: null,
            provinceRules: [
                v => !!v || !this.showingProvinces.length || this.$t('front.validation.province.required'),
            ],
            supportedCountries: [],
            currency: undefined,
            supportedCurrenciesCodes: [],
            allowSecurityQuestions: false,
            securityQuestion: null,
            securityQuestions: [],
            firstName: '',
            firstNameRules: [
                v => !!v || this.$t('front.validation.first_name.required'),
                v => v && /^[a-zA-Z'\s-]+$/.test(v) || this.$t('front.validation.common.only_latin'),
                v => v && /^[a-zA-Z'\s-]{2,}$/.test(v) || this.$t('front.validation.common.min_2_chars'),
            ],
            lastName: '',
            lastNameRules: [
                v => !!v || this.$t('front.validation.last_name.required'),
                v => v && /^[a-zA-Z'\s-]+$/.test(v) || this.$t('front.validation.common.only_latin'),
                v => v && /^[a-zA-Z'\s-]{2,}$/.test(v) || this.$t('front.validation.common.min_2_chars'),
            ],
            address: '',
            addressRules: [
                v => !!v || this.$t('front.validation.address.required'),
                v => v && /^[A-Za-z0-9'.\-\s,]+$/.test(v) || this.$t('front.validation.common.only_latin'),
                v => v && /^[A-Za-z0-9'.\-\s,]{2,}$/.test(v) || this.$t('front.validation.common.min_2_chars'),
            ],
            city: '',
            cityRules: [
                v => !!v || this.$t('front.validation.city.required'),
                v => v && /^([a-zA-Z]+([\s\-'][a-zA-Z]+)*)$/.test(v) || this.$t('front.validation.common.only_latin'),
                v => v && /^([a-zA-Z]+([\s.\-'][a-zA-Z]+)*){2,}$/.test(v) || this.$t('front.validation.common.min_2_chars'),
            ],
            allowPostalCode: false,
            postalCode: null,
            postalCodeRules: [
                v => !!v || this.$t('front.validation.postal_code.required'),
                v => v && v.length > 1 || this.$t('front.validation.common.min_2_chars'),
                v => v && /[^0]+/.test(v) || this.$t('front.validation.postal_code.not_only_zero'),
                v => v && /^[a-zA-Z0-9]+$/.test(v) || this.$t('front.validation.common.only_latin'),
            ],
            referralLinkCode: null,
            agentCode: '',
            answer: null,
            answerRules: [
                v => !!v || this.$t('front.validation.answer.required'),
                v => v && /^[a-zA-Z0-9]+$/.test(v) || this.$t('front.validation.common.only_latin'),
            ],
            username: undefined,
            usernameRules: [
                v => !!v || this.$t('front.validation.username.required'),
                v => v && v.length > 7 || this.$t('front.validation.username.min_8_chars'),
                v => v && /^[a-zA-Z0-9]+$/.test(v) || this.$t('front.validation.common.only_latin'),
                v => v && /[a-zA-Z]+/.test(v) || this.$t('front.validation.username.char_contains'),
            ],
            cpfCnpj: undefined,
            cpfCnpjRules: [
                v => !!v || this.$t('front.validation.cpf_cnpj.required'),
            ],
            email: '',
            emailRules: [
                v => !!v || this.$t('front.validation.email.required'),
                v => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || this.$t('front.validation.email.not_valid'),
            ],
            password: '',
            passwordRules: [
                v => !!v || this.$t('front.validation.password.required'),
                v => v && v.length > 5 || this.$t('front.validation.password.min_6_chars'),
                v => v && (/\d/.test(v) || /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(v)) || this.$t('front.validation.password.number_or_special_char'),
            ],
            phone: undefined,
            internationalPhone: undefined,
            verifiedPhone: undefined,
            isPhoneNumberValid: false,
            isPhoneUniqueCheckPassed: false,
            regulationsCheck: false,
            regulationsCheckRules: [
                v => !!v || this.$t('front.validation.conditions.agree'),
            ],
            subscribeNewsCheck: true,
            bodyElement: undefined,
            scrollPosition: 0,
            mdiRefresh: mdiRefresh,
        };
    },

    created() {
        let date = new Date();
        date.setFullYear(date.getFullYear() - 18);

        this.maxAllowedBirthDate = this.currentPickerDate = date.toISOString().slice(0, 10);
        // set for start showing currentPickerDate
        this.currentPickerDate = this.maxAllowedBirthDate;
    },

    watch: {
        modalDate(isOpen) {
            // reset currentPickerDate for allowing change date (fix v-date-picker bug)
            isOpen && setTimeout(() => this.currentPickerDate = undefined, 500);
        },
    },

    mounted() {
        checkRegisterAvailability(this.createApiData())
            .then(() => {
                this.step = 1;

                this.referralLinkCode = getStoredReferralLinkCode();

                fetchRegistrationFormData(this.createApiData({
                    referralLinkCode: this.referralLinkCode,
                }))
                    .then(registrationData => {
                        this.supportedCountries = registrationData.supportedCountries;
                        this.supportedCurrenciesCodes = registrationData.supportedCurrenciesCodes;

                        this.allowPostalCode = registrationData.allowPostalCode;
                        this.allowSecurityQuestions = registrationData.allowSecurityQuestions;

                        if (this.allowSecurityQuestions) {
                            this.securityQuestions = registrationData.securityQuestions;
                            this.securityQuestion = registrationData.securityQuestions.length && registrationData.securityQuestions[0];
                        }

                        this.countryCode = registrationData.geoData.countryCode;
                        this.currency = registrationData.geoData.currencyCode;

                        this.useAgentCode = registrationData.useAgentCode;
                        this.overrideAgentCodeAllowed = registrationData.overrideAgentCodeAllowed;
                        this.loginUserAfterRegistration = registrationData.loginUserAfterRegistration;
                        this.phoneVerificationAllowed = registrationData.phoneVerificationAllowed;
                        this.minUserAgeForRegistration = registrationData.minUserAgeForRegistration;

                        if (this.useAgentCode && this.referralLinkCode) {
                            if (registrationData.agentCode) {
                                this.agentCode = registrationData.agentCode;
                            } else {
                                // todo if needing show message if #signup presents in route (guest enter right now via link)
                                // this.makeErrorToast(this.$t('front.agent.messages.wrong_referral_link_code'));
                            }
                        }
                    })
                    .catch(() => {
                        this.registrationUnavailableReason = this.$t('front.sign_in.register.messages.service_unavailable');

                        this.trackRegistrationUnavailableUserEvent();

                        this.step = 5;
                    });
            })
            .catch(error => {
                let errorResponse = error && error.response;

                if (errorResponse && error.response.status === 422) {
                    this.registrationUnavailableReason = errorResponse && error.response.data && error.response.data.message;
                } else {
                    this.registrationUnavailableReason = this.$t('front.sign_in.register.messages.service_unavailable');
                }

                this.trackRegistrationUnavailableUserEvent();

                this.step = 5;
            });
    },

    computed: {
        dialogTitle() {
            if (this.step < 4) {
                return this.$t('front.sign_in.register.titles.modal_title.step', {
                    step: this.step > 2 && !this.phoneVerificationAllowed ? this.step - 1 : this.step,
                    stepsCount: this.phoneVerificationAllowed ? 3 : 2
                })
            } else if (this.step === 4) {
                return this.$t('front.sign_in.register.titles.modal_title.success');
            } else {
                return '&nbsp;';
            }
        },

        enterPhoneDescription() {
            return this.phoneVerificationAllowed ? this.$t('front.sign_in.register.descriptions.enter_mobile_detailed') : this.$t('front.sign_in.register.descriptions.enter_no_validate_mobile_detailed');
        },

        enterPhoneButtonText() {
            return (!this.phoneVerificationAllowed || this.phoneVerified) ? this.$t('front.sign_in.register.button.continue_registration') : this.$t('front.sign_in.register.button.request_code');
        },

        phoneVerified() {
            return this.verifiedPhone && this.internationalPhone === this.verifiedPhone;
        },

        preloaderBackgroundImage() {
            return `/public/${brandName}/spinners/bank-spinner.gif`;
        },

        birthdayRules() {
            return [
                v => !!v || this.$t('front.validation.birthday.required'),
                v => moment(v, this.birthdayFormat, true).isValid() || this.$t('front.validation.birthday.date_invalid'),
                v => moment(v, this.birthdayFormat, true).add(this.minUserAgeForRegistration, 'years') <= moment() || this.$t('front.validation.birthday.age_limit', {minUserAge: this.minUserAgeForRegistration}),
            ];
        },

        birthdayFormat() {
            return this.$store.state.appLocale && this.$store.state.appLocale.dateFormat || 'DD-MM-YYYY';
        },

        showingCountries() {
            let groupedCountries = [];

            appCountries.countriesGroups.forEach(group => {
                let groupCountries = this.supportedCountries.filter(country => group.countries.includes(country.code));

                if (groupCountries.length) {
                    // add group countries
                    groupedCountries = groupedCountries.concat(groupCountries);

                    // add line divider
                    groupedCountries.push({
                        header: '',
                        disabled: true,
                        divider: true,
                    });
                }
            });

            if (groupedCountries.length) {
                return groupedCountries.concat(this.supportedCountries.filter(country => !this.preferredCountries.includes(country.code)));
            } else {
                return this.supportedCountries;
            }
        },

        showingProvinces() {
            let selectedCountry = this.countryCode && this.supportedCountries.find(country => country.code === this.countryCode);
            return selectedCountry && selectedCountry.provincesAllowed && selectedCountry.provinces || [];
        },

        preferredCountries() {
            return appCountries.countriesGroups.reduce((preferredCountries, countryGroup) => {
                return preferredCountries.concat(countryGroup.countries);
            }, [])
        },

        locale() {
            return this.$store.state.locale;
        },

        termsAndConditionsRoute() {
            let languageUrlPrefix = this.$store.getters.getLanguageUrlPrefix();
            return `${languageUrlPrefix}/terms-and-conditions`;
        },

        privacyAndCookiePolicyRoute() {
            let languageUrlPrefix = this.$store.getters.getLanguageUrlPrefix();
            return `${languageUrlPrefix}/privacy-and-cookie-policy`;
        },

        registrationPromo() {
            return this.$store.getters.getLayoutPagePart('userRegistrationPromoBlock');
        },
    },

    methods: {
        saveCalendarBirthday() {
            this.formattedBirthday = moment(this.calendarBirthday).format(this.birthdayFormat);

            this.modalDate = false;
        },

        trackRegistrationUnavailableUserEvent() {
            void require('../../../../../src/util/analytics/index').trackEvent(eventsInterface.registrationUnavailable, this, {
                category: 'User Auth',
                action: 'Registration error',
                label: this.registrationUnavailableReason,
            });
        },

        decrementStep() {
            if (this.step === 2) {
                this.step = 1;
            } else if (this.step === 3) {
                if (this.phoneVerificationAllowed) {
                    this.code_1 = this.code_2 = this.code_3 = this.code_4 = this.code = '';
                    this.phoneVerificationCodeSent = false;

                    this.step = 2;
                } else {
                    this.step = 1;
                }
            }
        },

        verificationCodeInput({target}, index) {
            let number = parseInt(target.value);

            if (Number.isInteger(number)) {
                this.code = this.code_1 + '' + this.code_2 + '' + this.code_3 + '' + this.code_4;

                if (this.code.length === 4) {
                    this.phoneCodeValid = true;
                } else {
                    if (target.nextElementSibling) {
                        target.nextElementSibling.focus()
                    }
                }
            } else {
                this[`code_${index}`] = '';
            }
        },

        openLogin() {
            this.$emit('openLogin');
        },

        changePhoneValidationStatus({number, isValid}) {
            if (isValid && !this.isPhoneNumberValid) {
                this.internationalPhone = number && number.e164;
            }

            this.isPhoneNumberValid = isValid;
        },

        phoneInput(phoneNumber, {number}) {
            this.isPhoneUniqueCheckPassed = false;

            this.internationalPhone = number && number.e164;

            // replace wrong rtl package's mask with plain phone number
            /*if (this.$vuetify.rtl && phoneNumber) {
                this.phone = phoneNumber.replace(/\D/g, '');
                //this.phone = phoneNumber.replace(/\s/g, '');
            }*/
        },

        submitFormOne() {
            if (!this.$refs.formOne.validate()) {
                return;
            }

            this.loading = true;

            checkUserRegistrationData(this.createApiData({
                username: this.username,
                email: this.email,
                docNumber: this.cpfCnpj,
            }))
                .then(() => {
                    if (this.phoneVerificationAllowed) {
                        getPhoneVerificationCaptcha()
                            .then(captcha => {
                                this.loading = false;

                                if (Object.keys(captcha).length) {
                                    this.captcha = captcha;
                                }

                                this.step = 2;
                            })
                            .catch(() => {
                                this.loading = false;

                                this.step = 2;
                            });
                    } else {
                        this.loading = false;

                        this.step = 3;
                    }
                })
                .catch(error => {
                    this.loading = false;

                    let errors = error.response && error.response.data && error.response.data.errors;

                    if (errors && errors.length) {
                        this.makeErrorToast(null, errors);
                    } else {
                        let message = error.response && error.response.data && error.response.data.message;

                        if (message) {
                            this.makeErrorToast(message);
                        } else {
                            this.makeUnavailableToast();
                        }
                    }
                });
        },

        submitFormTelephone() {
            if (this.$refs.formTelephone.validate()) {
                if (this.isPhoneUniqueCheckPassed) {
                    if (this.phoneVerified) {
                        this.step++;
                    } else {
                        this.sendPhoneVerificationCode();
                    }
                } else {
                    this.loading = true;

                    checkUserRegistrationPhone(this.createApiData({
                        phone: this.internationalPhone,
                    }))
                        .then(() => {
                            this.loading = false;
                            this.isPhoneUniqueCheckPassed = true;

                            if (this.phoneVerified) {
                                this.step++;
                            } else {
                                this.sendPhoneVerificationCode();
                            }
                        })
                        .catch(error => {
                            this.loading = false;

                            let errorResponse = error && error.response;

                            if (errorResponse && error.response.status === 422) {
                                this.makeErrorToast(error.response.data.message)
                            } else {
                                this.makeUnavailableToast();
                            }
                        });
                }
            }
        },

        sendPhoneVerificationCode() {
            this.loading = true;

            let data = {
                phone: this.internationalPhone,
            };

            if (this.captcha) {
                data.captchaValue = this.captchaValue;
                data.captchaKey = this.captcha.key;
            }

            sendPhoneVerificationCode(this.createApiData(data))
                .then(response => {
                    this.loading = false;
                    this.phoneVerificationCodeSent = true;
                    response.message && this.makeSuccessToast(response.message);
                })
                .catch(error => {
                    this.loading = false;

                    let status = error && error.response && error.response.status;
                    let data = error && error.response && error.response.data;

                    this.captcha = data && data.captcha;
                    this.captchaValue = null;

                    if (status === 422) {
                        data && data.message && this.makeInfoToast(data.message);
                    } else {
                        data && data.message && this.makeErrorToast(data.message);
                    }
                });
        },

        editPhoneNumber() {
            this.loading = true;

            getPhoneVerificationCaptcha()
                .then(captcha => {
                    this.loading = false;
                    this.captcha = captcha;
                    this.phoneVerificationCodeSent = null;
                })
                .catch(() => {
                    this.loading = false;
                    this.phoneVerificationCodeSent = null;
                });
        },

        refreshCaptcha() {
            this.loading = true;

            getPhoneVerificationCaptcha({
                refresh: true,
            })
                .then(captcha => {
                    this.loading = false;
                    this.captcha = captcha;
                    this.captchaValue = null;
                })
                .catch(() => {
                    this.loading = false;
                    this.captcha = null;
                });
        },

        submitFormCode() {
            this.loading = true;

            checkPhoneVerificationCode(this.createApiData({
                phone: this.internationalPhone,
                code: this.code,
            }))
                .then(() => {
                    this.loading = false;
                    this.verifiedPhone = this.internationalPhone;
                    this.step = 3;
                })
                .catch(error => {
                    this.loading = false;

                    if (error && error.response && error.response.status === 422) {
                        this.makeErrorToast(this.$t('front.sign_in.register.messages.wrong_verification_code'));
                    } else {
                        this.makeUnavailableToast();
                    }
                });
        },

        submitFormDetails() {
            if (this.$refs.formDetails.validate()) {
                this.loading = true;

                let registrationData = {
                    docNumber: this.cpfCnpj,
                    username: this.username,
                    password: this.password,
                    currencyCode: this.currency,
                    email: this.email,
                    securityQuestion: this.securityQuestion,
                    securityAnswer: this.answer,
                    firstName: this.firstName,
                    lastName: this.lastName,
                    isMale: this.gender === 'Male',
                    birthDate: moment(this.formattedBirthday, this.birthdayFormat, true).format("YYYY-MM-DD"),
                    address: this.address,
                    countryCode: this.countryCode,
                    provinceCode: this.provinceCode,
                    postalCode: this.postalCode,
                    city: this.city,
                    mobile: this.internationalPhone,
                    subscribeToReceiveEmails: this.subscribeNewsCheck,
                    referralLinkCode: this.referralLinkCode,
                    agentCode: this.agentCode,
                    userTrackingCodes: createRegistrationUserTrackingCodes(),
                };

                registerUser(this.createApiData(registrationData))
                    .then(() => {
                        this.loading = false;

                        this.step = 4;

                        if (this.loginUserAfterRegistration) {
                            setTimeout(() => this.loginUser(), 2000);
                        }

                        try {
                            void require('../../../../../src/util/analytics/index').trackEvent(eventsInterface.registerUser, this, {
                                registrationData: registrationData,
                            });

                            clearReferralData(this);
                        } catch (e) {
                            console.log('Error in Register.vue registerUser()', e)
                        }
                    })
                    .catch(error => {
                        this.loading = false;

                        let status = error && error.response && error.response.status;
                        let errorMessage = error && error.response && error.response.data && error.response.data.message;
                        let errors = error && error.response && error.response.data && error.response.data.errors;

                        if (status === 422 && errorMessage) {
                            this.makeErrorToast(errorMessage, errors);
                        } else {
                            this.makeErrorToast(this.$t('front.sign_in.register.messages.service_unavailable'));
                        }
                    });
            }
        },

        makeUnavailableToast() {
            this.makeErrorToast(this.$t('front.sign_in.register.messages.service_unavailable'));
        },

        loginUser() {
            loginUser(this.createApiData(createLoginData(this.username, this.password, this.locale)))
                .then(user => {
                    this.$store.commit('SET_USER', user);

                    let redirectPath = this.$store.getters.getLanguageUrlPrefix() || '/';
                    this.$router.push(redirectPath);
                })
                .catch(error => console.log('Error in Register.vue loginUser()', error));
        }
    }
}
</script>

<style lang="sass">
@import "sass/components/signIn/RegistrationForm"
</style>
